// Mock Data für Dion Hair Clinic - Köln Landing Page

export const variant = "koeln";
export const variantLabel = "Köln";

export const clinicInfo = {
  name: "Dion Hair Clinic",
  tagline: "Ihr Experte für Haartransplantation in Köln und Umgebung",
  phone: "+49 2161 2963017",
  email: "info@dionhairclinic.de",
  website: "www.dionhairclinic.de",
  address: {
    street: "Schürenweg 61",
    city: "41063 Mönchengladbach",
    country: "Deutschland"
  },
  openingHours: {
    weekdays: "Mo - Fr: 9:00 - 18:00 Uhr",
    saturday: "Sa: 10:00 - 14:00 Uhr",
    sunday: "So: Geschlossen"
  }
};

export const heroContent = {
  title: "Natürliche Haartransplantation",
  subtitle: "in Köln",
  description: "Modernste FUE-Technologie, erfahrene Spezialisten und natürlich aussehende Ergebnisse. Vertrauen Sie der führenden Haarklinik im Rheinland.",
  ctaPrimary: "Kostenlose Beratung",
  ctaSecondary: "Kostenlose Beratung",
  badge: "Führende Haarklinik in Köln"
};

export const stats = [
  { value: "5.000+", label: "Erfolgreiche Behandlungen" },
  { value: "15+", label: "Jahre Erfahrung" },
  { value: "98%", label: "Zufriedene Patienten" },
  { value: "4.9★", label: "Google Bewertung" }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&auto=format",
    title: "Patient 1",
    grafts: "3.500 Grafts",
    technique: "FUE Saphir"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&auto=format",
    title: "Patient 2",
    grafts: "4.200 Grafts",
    technique: "DHI Methode"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&auto=format",
    after: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&auto=format",
    title: "Patient 3",
    grafts: "2.800 Grafts",
    technique: "FUE Saphir"
  }
];

export const expertise = [
  {
    id: 1,
    icon: "Shield",
    title: "Modernste Technologie",
    description: "Wir verwenden ausschließlich die neuesten FUE- und DHI-Techniken mit Saphirklingen für minimale Narbenbildung."
  },
  {
    id: 2,
    icon: "Award",
    title: "Erfahrene Spezialisten",
    description: "Unser Team besteht aus zertifizierten Haarchirurgen mit über 15 Jahren Erfahrung in der Haartransplantation."
  },
  {
    id: 3,
    icon: "Heart",
    title: "Natürliche Ergebnisse",
    description: "Wir garantieren natürlich aussehende Haarlinien, die perfekt zu Ihrer Gesichtsform passen."
  },
  {
    id: 4,
    icon: "Clock",
    title: "Schnelle Erholung",
    description: "Dank minimalinvasiver Techniken sind die meisten Patienten innerhalb weniger Tage wieder einsatzbereit."
  },
  {
    id: 5,
    icon: "Euro",
    title: "Transparente Preise",
    description: "Keine versteckten Kosten. Sie erhalten ein detailliertes Angebot vor Ihrer Behandlung."
  },
  {
    id: 6,
    icon: "Users",
    title: "Persönliche Betreuung",
    description: "Von der ersten Beratung bis zur Nachsorge - wir begleiten Sie auf Ihrem gesamten Weg."
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Kostenlose Beratung",
    description: "Vereinbaren Sie einen Termin für Ihre persönliche Haaranalyse. Unsere Experten bewerten Ihren Haarausfall und erstellen einen individuellen Behandlungsplan.",
    icon: "MessageSquare"
  },
  {
    step: 2,
    title: "Detaillierte Planung",
    description: "Mit KI-basierter Trichoskopie analysieren wir Ihre Haarstruktur und besprechen die optimale Anzahl der Grafts sowie die Haarlinie.",
    icon: "Sparkles"
  },
  {
    step: 3,
    title: "Die Behandlung",
    description: "Am Behandlungstag werden Sie von unserem erfahrenen Team betreut. Die Prozedur dauert je nach Umfang 4-8 Stunden unter lokaler Betäubung.",
    icon: "Stethoscope"
  },
  {
    step: 4,
    title: "Nachsorge",
    description: "Wir geben Ihnen detaillierte Pflegeanweisungen und sind für alle Ihre Fragen da. Regelmäßige Kontrolltermine sichern optimale Ergebnisse.",
    icon: "HeartHandshake"
  },
  {
    step: 5,
    title: "Das Ergebnis",
    description: "Nach 12-18 Monaten sehen Sie das vollständige Ergebnis: dichtes, natürlich aussehendes Haar, das ein Leben lang hält.",
    icon: "Trophy"
  }
];

export const pricing = [
  {
    id: 1,
    name: "Basic",
    features: [
      "FUE Saphir Methode",
      "Lokale Betäubung",
      "Nachsorgekit (Nackenkissen, Shampoo) + Medikamentenrezept",
      "6 Monate Nachbetreuung",
      "1 Regenerative Haartherapie"
    ],
    tiers: [
      { grafts: "bis 2.000 Grafts", price: "2.999" },
      { grafts: "bis 4.500 Grafts", price: "3.499" }
    ],
    hybridPrice: "799",
    popular: false
  },
  {
    id: 2,
    name: "Advanced",
    features: [
      "FUE Saphir Methode",
      "Schmerzfreie Betäubung",
      "Nachsorgekit (Nackenkissen, Shampoo, Pflegespray und Medikamente)",
      "12 Monate Nachbetreuung",
      "3 Regenerative Haartherapien"
    ],
    tiers: [
      { grafts: "bis 2.000 Grafts", price: "3.499" },
      { grafts: "bis 4.500 Grafts", price: "4.099" }
    ],
    hybridPrice: "699",
    popular: true
  },
  {
    id: 3,
    name: "Premium",
    features: [
      "FUE Saphir Methode",
      "Schmerzfreie Betäubung",
      "Nachsorgekit (Nackenkissen, Shampoo, Pflegespray und Medikamente)",
      "18 Monate Nachbetreuung",
      "5 Regenerative Haartherapien",
      "Hotelübernachtung inklusive"
    ],
    tiers: [
      { grafts: "bis 2.000 Grafts", price: "4.099" },
      { grafts: "bis 4.500 Grafts", price: "4.699" }
    ],
    hybridPrice: "599",
    popular: false
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sotirios Tsomkopoulos",
    role: "Facharzt für Thoraxchirurgie & Haartransplantationschirurg",
    video: "https://customer-assets.emergentagent.com/job_themeswitch-2/artifacts/wmewma40_video%285%29.mp4",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/x1tzbzpk_sortiris.jpeg",
    description: "Dr. Tsomkopoulos ist Facharzt für Thoraxchirurgie mit Approbation in Deutschland und der Schweiz. Er verfügt über langjährige Erfahrung als leitender Haartransplantationschirurg in renommierten Kliniken in Berlin, Basel und Thessaloniki.",
    specialization: "ISHRS-Mitglied, FUE & DHI Spezialist, Approbation DE/CH"
  },
  {
    id: 2,
    name: "Blerina Bevapi",
    role: "Fachärztin für Innere Medizin und Expertin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/if5w0ce2_bevapi.mp4",
    image: "/images/optimized/Blerina-Bevapi.webp",
    description: "Mit ihrer umfassenden medizinischen Expertise und spezialisiertem Wissen im Bereich Haartransplantationen sorgt Dr. Bevapi für höchste medizinische Standards und optimale Behandlungsergebnisse.",
    specialization: "Fachärztin für Innere Medizin, Spezialisierung auf Haartransplantationstechniken"
  },
  {
    id: 3,
    name: "Dilek Ergüney",
    role: "Medizinische Haartechnikerin",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/i3r32fur_ergueney.mp4",
    image: "/images/optimized/Dilek-Ergueney.webp",
    description: "Dilek Ergüney bringt umfangreiche Erfahrung in der präzisen Durchführung von Haartransplantationstechniken mit und ist spezialisiert auf die sorgfältige Handhabung von Haarfollikeln für optimale Ergebnisse.",
    specialization: "Zertifizierte medizinische Haartechnikerin mit Spezialisierung auf FUE- und DHI-Techniken"
  },
  {
    id: 4,
    name: "Songül Bulut",
    role: "Spezialistin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/mvg2maej_bulut.mp4",
    image: "/images/optimized/Songuel-Bulut.webp",
    description: "Songül Bulut absolvierte ihr Medizinstudium in der Türkei und sammelte jahrelange Erfahrung in führenden Haarkliniken weltweit. Ihre internationale Expertise garantiert erstklassige Behandlungsergebnisse.",
    specialization: "Medizinstudium in der Türkei, internationale Erfahrung in führenden Haarkliniken"
  }
];

export const clinicImages = [
  {
    id: 1,
    src: "/images/optimized/DionHairClinic_Eingang.webp",
    alt: "Klinik Eingang",
    title: "Unsere Klinik"
  },
  {
    id: 2,
    src: "/images/optimized/DionHairClinic_Flur.webp",
    alt: "Klinik Flur",
    title: "Moderner Flur"
  },
  {
    id: 3,
    src: "/images/optimized/DionHairClinic_OP_Raum.webp",
    alt: "OP Raum",
    title: "Steriler OP-Raum"
  },
  {
    id: 4,
    src: "/images/optimized/DionHairClinic_Wartebereich.webp",
    alt: "Wartebereich",
    title: "Eleganter Wartebereich"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Markus K.",
    location: "Köln",
    rating: 5,
    text: "Nach jahrelangem Haarverlust habe ich endlich den Schritt gewagt. Das Ergebnis übertrifft alle meine Erwartungen! Das Team war unglaublich professionell und einfühlsam.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&auto=format",
    treatment: "FUE Saphir, 3.200 Grafts"
  },
  {
    id: 2,
    name: "Stefan M.",
    location: "Düsseldorf",
    rating: 5,
    text: "Von der ersten Beratung bis zur Nachsorge - alles war perfekt organisiert. Mein Selbstbewusstsein ist zurück!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&auto=format",
    treatment: "DHI Methode, 2.800 Grafts"
  },
  {
    id: 3,
    name: "Andreas B.",
    location: "Bonn",
    rating: 5,
    text: "Ich war anfangs skeptisch, aber die Ergebnisse sprechen für sich. Die Haarlinie sieht absolut natürlich aus. Vielen Dank an das gesamte Team!",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&auto=format",
    treatment: "FUE Saphir, 4.000 Grafts"
  }
];

export const faqItems = [
  {
    question: "Wie lange dauert eine Haartransplantation?",
    answer: "Je nach Anzahl der zu transplantierenden Grafts dauert der Eingriff zwischen 4 und 8 Stunden. Sie können während der Behandlung Musik hören, Filme schauen oder sich entspannen."
  },
  {
    question: "Ist die Behandlung schmerzhaft?",
    answer: "Nein, die Behandlung erfolgt unter lokaler Betäubung und ist praktisch schmerzfrei. Nur die initiale Betäubung kann als leichtes Piksen empfunden werden."
  },
  {
    question: "Wann sehe ich die ersten Ergebnisse?",
    answer: "Die transplantierten Haare fallen zunächst aus (Shock Loss), was normal ist. Nach 3-4 Monaten beginnt das neue Wachstum, das volle Ergebnis sehen Sie nach 12-18 Monaten."
  },
  {
    question: "Wie hoch ist die Anwachsrate?",
    answer: "Bei unseren Behandlungen liegt die Anwachsrate bei über 95%. Durch unsere langjährige Erfahrung und modernste Techniken erzielen wir hervorragende Ergebnisse."
  },
  {
    question: "An welchem Standort kann ich mich behandeln lassen?",
    answer: "Unsere Klinik befindet sich in Mönchengladbach und ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden."
  },
  {
    question: "Sind die Ergebnisse dauerhaft?",
    answer: "Ja! Die transplantierten Haare stammen aus dem Spenderbereich am Hinterkopf, der genetisch resistent gegen Haarausfall ist. Diese Haare wachsen ein Leben lang."
  }
];

// Feature flags for this variant
export const features = {
  showAIAnalysis: true,
  analysisType: "hair", // hair, beard, eyebrow
  showPricing: true,
  showBeforeAfter: true,
  showTeam: true,
  showClinic: true
};
